import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

// Social and contact links rendered in the hero and the contact section.
export const socialLinks = [
  {
    id: 'github',
    label: 'GitHub',
    href: 'https://github.com/georgekalokyris',
    icon: faGithub,
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/george-kalokyris-3999a3b8/',
    icon: faLinkedin,
  },
  {
    id: 'email',
    label: 'Email',
    href: 'mailto:kalokirisg@gmail.com',
    icon: faEnvelope,
  },
];

export const SocialLinks = ({ className = 'social-links' }) => (
  <ul className={className}>
    {socialLinks.map((link) => (
      <li key={link.id}>
        <a
          href={link.href}
          aria-label={link.label}
          title={link.label}
          {...(link.href.startsWith('mailto:')
            ? {}
            : { target: '_blank', rel: 'noopener noreferrer' })}
        >
          <FontAwesomeIcon icon={link.icon} aria-hidden="true" />
        </a>
      </li>
    ))}
  </ul>
);

export default SocialLinks;
